module.exports = __webpack_public_path__ + "img/li-back.8c89a464.png";